// @ts-nocheck
import React from "react";
import { Box } from "src/components/Core/Box";
import Loading from "src/shared/Loading";
import { DemographicLocationsGraphContainer } from "./container";
import PieChartGraphCard from "../PieChartGraphCard";

interface Props {
  loading: boolean;
  data: Array<any>;
  chartDataType: string;
  setChartDataType: (value: string) => void;
  isShowFilter: boolean;
}

const DemographicLocationsGraph: React.FC<Props> = ({
  loading,
  data,
  chartDataType,
  setChartDataType,
  isShowFilter,
}) => {
  return (
    <Box background="#FFFFFF" p={10} borderRadius="2px">
      <Loading spinning={loading}>
        <PieChartGraphCard
          title="Demographic: Locations"
          data01={data}
          chartDataType={chartDataType}
          setChartDataType={value => setChartDataType(value)}
          isShowFilter={isShowFilter}
        />
      </Loading>
    </Box>
  );
};

export { DemographicLocationsGraph, DemographicLocationsGraphContainer };
